import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
  Accordion,
  AccordionHeader,
  AccordionBody,
  Menu,
  MenuList,
  Avatar,
  MenuItem,
  MenuHandler,
  IconButton,
  Drawer,
} from '@material-tailwind/react';
import {
  UserCircleIcon,
  InboxIcon,
  AdjustmentsHorizontalIcon,
  XMarkIcon,
  KeyIcon,
  ArrowLeftStartOnRectangleIcon,
  UserGroupIcon,
  NewspaperIcon,
  FolderIcon,
  ArrowTrendingUpIcon,
  WifiIcon,
  BellAlertIcon,
} from '@heroicons/react/24/solid';
import { ChevronRightIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { getCookie, refreshTokenNew, removeCookie } from '../../utils/helper';
import { isAdmin, isAdminOrModerator, isModerator, permissionLabel } from '../../utils/permissions';
import { Link, useNavigate } from 'react-router-dom';
import images from '../../assets/images';
import { listProductIDAllCount } from '../../services/apiBds';
import axios from 'axios';

function DashboardLayout({ children }) {
  const [open, setOpen] = useState(0);
  const [openDrawers, setOpenDrawers] = useState(false);
  const [countChoDuyet, setCountChoDuyet] = useState(0);
  const auth = getCookie('token');
  const navigate = useNavigate();
  refreshTokenNew();

  const openDrawer = () => setOpenDrawers(true);
  const closeDrawer = () => setOpenDrawers(false);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  useEffect(() => {
    document.title = 'Hệ Thống Bất Động Sản KEYLAND';
    listTinChoDuyet();
    // axios
    //   .get('https://ipinfo.io/json?token=6ad78cbb570814')
    //   .then((response) => {
    //     if (response.data.ip !== auth?.wifi && (isModerator(auth) || Number(auth?.permission) === 4)) {
    //       removeCookie('token');
    //       removeCookie('token_sv');
    //       removeCookie('exp_sv');
    //       navigate('/login', { replace: true });
    //     }
    //   })
    //   .catch((error) => {
    //     console.error('Error fetching IP address:', error);
    //   });
  }, []);

  const listTinChoDuyet = async () => {
    const countBds = await listProductIDAllCount(3);
    setCountChoDuyet(countBds.totalRows);
  };

  return (
    <div className="m-auto p-1 bg-[#fffdf4]">
      <div className="grid grid-cols-1 md:grid-cols-6 gap-x-3">
        {/* Sidebar */}
        <div className="hidden lg:block self-start sticky top-1 h-[calc(100vh-1rem)] overflow-y-scroll">
          <div className=" w-full">
            <div className="p-2 ">
              <div className="flex justify-center">
                <Link to="/">
                  <Typography
                    variant="h5"
                    color="blue-gray"
                    className="font-[UTM-Avo] text-orange-300 text-lg whitespace-nowrap cursor-pointer"
                  >
                    KEYLAND
                  </Typography>
                </Link>
              </div>
              <div className="mt-4 flex items-center justify-center">
                <Menu>
                  <MenuHandler>
                    <Avatar variant="circular" alt="tania andrew" className="cursor-pointer" src={images.avt} />
                  </MenuHandler>
                  <MenuList>
                    <Link to="/user">
                      <MenuItem className="flex items-center gap-2">
                        <UserCircleIcon className="h-5 w-5" />

                        <Typography variant="small" className="font-medium">
                          Thông tin
                        </Typography>
                      </MenuItem>
                    </Link>
                    <Link to="/changepass">
                      <MenuItem className="flex items-center gap-2">
                        <KeyIcon className="w-5 h-5" />

                        <Typography variant="small" className="font-medium">
                          Đổi mật khẩu
                        </Typography>
                      </MenuItem>
                    </Link>
                    <hr className="my-2 border-blue-gray-50" />
                    <MenuItem className="flex items-center gap-2 ">
                      <ArrowLeftStartOnRectangleIcon className="w-5 h-5" />
                      <Typography
                        variant="small"
                        className="font-medium"
                        onClick={() => {
                          removeCookie('token');
                          removeCookie('token_sv');
                          removeCookie('exp_sv');
                          navigate('/login');
                          window.location.href = '/login';
                        }}
                      >
                        Đăng xuất
                      </Typography>
                    </MenuItem>
                  </MenuList>
                </Menu>
                <label className="text-base ml-4">
                  <b>{auth?.name}</b>
                  <br />
                  <i className="text-sm">({permissionLabel(auth)})</i>
                </label>
              </div>
            </div>
            <hr className="my-2 border-blue-gray-50" />
            <List className="min-w-0">
              {isAdmin(auth) && (
                <Accordion
                  open={open === 1}
                  icon={
                    <ChevronDownIcon
                      strokeWidth={2.5}
                      className={` mx-auto h-4 w-4 transition-transform ${open === 1 ? 'rotate-180' : ''}`}
                    />
                  }
                >
                  <ListItem className="p-0" selected={open === 1}>
                    <AccordionHeader onClick={() => handleOpen(1)} className="border-b-0 p-3 min-w-0">
                      <ListItemPrefix>
                        <UserGroupIcon className="h-5 w-5 " />
                      </ListItemPrefix>
                      <Typography color="blue-gray" className="mr-auto font-normal ">
                        Q.L Nhân Viên
                      </Typography>
                    </AccordionHeader>
                  </ListItem>
                  <Link to="/users">
                    <AccordionBody className="py-1">
                      <List className="p-0 min-w-0">
                        <ListItem>
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Thêm nhân viên
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/dsusers">
                    <AccordionBody className="py-1">
                      <List className="p-0 min-w-0">
                        <ListItem>
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Danh sách nhân viên
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  {/* <Link to="/team">
                    <AccordionBody className="py-1">
                      <List className="p-0 min-w-0">
                        <ListItem>
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Thêm NV vào Team
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link> */}
                </Accordion>
              )}

              <Accordion
                open={open === 2}
                icon={
                  <ChevronDownIcon
                    strokeWidth={2.5}
                    className={`mx-auto h-4 w-4 transition-transform ${open === 2 ? 'rotate-180' : ''}`}
                  />
                }
              >
                <ListItem className="p-0" selected={open === 2}>
                  <AccordionHeader onClick={() => handleOpen(2)} className="border-b-0 p-3">
                    <ListItemPrefix>
                      <NewspaperIcon className="h-5 w-5 " />
                    </ListItemPrefix>
                    <Typography color="blue-gray" className="mr-auto font-normal ">
                      Q.L Bất Động Sản
                    </Typography>
                  </AccordionHeader>
                </ListItem>
                <Link to="/addbds">
                  <AccordionBody className="py-1">
                    <List className="p-0  min-w-0">
                      <ListItem className="">
                        <ListItemPrefix>
                          <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                        </ListItemPrefix>
                        Thêm tin BĐS
                      </ListItem>
                    </List>
                  </AccordionBody>
                </Link>
                <Link to="/dsbds">
                  <AccordionBody className="py-1">
                    <List className="p-0  min-w-0">
                      <ListItem className="">
                        <ListItemPrefix>
                          <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                        </ListItemPrefix>
                        Danh sách tin BĐS
                      </ListItem>
                    </List>
                  </AccordionBody>
                </Link>
              </Accordion>
              <hr className="my-2 border-blue-gray-50" />

              {(isAdmin(auth) || isModerator(auth)) &&
                (auth['wifi'] !== auth['lastiplogin'] && isModerator(auth) ? (
                  ''
                ) : (
                  <Link to="/dsduyetbds">
                    <ListItem className="">
                      <ListItemPrefix>
                        <InboxIcon className="h-5 w-5" />
                      </ListItemPrefix>
                      Kiểm Duyệt BĐS
                      {countChoDuyet > 0 && (
                        <ListItemSuffix>
                          <Chip
                            value={countChoDuyet}
                            size="sm"
                            variant="ghost"
                            color="blue-gray"
                            className="rounded-full text-deep-orange-600 bg-orange-200"
                          />
                        </ListItemSuffix>
                      )}
                    </ListItem>
                  </Link>
                ))}

              {isAdmin(auth) && (
                <Link to="/thongke">
                  <ListItem className="">
                    <ListItemPrefix>
                      <ArrowTrendingUpIcon className="h-5 w-5" />
                    </ListItemPrefix>
                    Thống Kê BĐS
                  </ListItem>
                </Link>
              )}

              {isAdmin(auth) && (
                <Link to="/wifi">
                  <ListItem className="">
                    <ListItemPrefix>
                      <WifiIcon className="h-5 w-5" />
                    </ListItemPrefix>
                    Wifi Nội Bộ
                  </ListItem>
                </Link>
              )}

              {isAdmin(auth) && (
                <Link to="/thong-bao">
                  <ListItem className="">
                    <ListItemPrefix>
                      <BellAlertIcon className="h-5 w-5" />
                    </ListItemPrefix>
                    Q.L Thông Báo
                  </ListItem>
                </Link>
              )}

              {isAdmin(auth) && (
                <div>
                  <hr className="my-2 border-blue-gray-50" />
                  <Accordion
                    open={open === 3}
                    icon={
                      <ChevronDownIcon
                        strokeWidth={2.5}
                        className={` mx-auto h-4 w-4 transition-transform ${open === 3 ? 'rotate-180' : ''}`}
                      />
                    }
                  >
                    <ListItem className="p-0 " selected={open === 3}>
                      <AccordionHeader onClick={() => handleOpen(3)} className="border-b-0 p-3">
                        <ListItemPrefix>
                          <FolderIcon className="h-5 w-5 " />
                        </ListItemPrefix>
                        <Typography color="blue-gray" className="mr-auto font-normal ">
                          Q.L Danh Mục
                        </Typography>
                      </AccordionHeader>
                    </ListItem>
                    <Link to="/diadiem">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Địa Điểm
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/phuonggroup">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Nhóm Phường
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/khuquyhoach">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Khu Quy Hoạch
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/quyhoach">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Quy Hoạch
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/phaply">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Pháp Lý
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/huongbds">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Hướng Đất
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/vitri">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Vị Trí
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/loaibds">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Loại BĐS
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/tiennghi">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Tiện Nghi
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                    <Link to="/dactrung">
                      <AccordionBody className="py-1">
                        <List className="p-0  min-w-0">
                          <ListItem className="">
                            <ListItemPrefix>
                              <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Q.L Đặc Trưng
                          </ListItem>
                        </List>
                      </AccordionBody>
                    </Link>
                  </Accordion>
                </div>
              )}
            </List>
          </div>
        </div>

        {/* content */}
        <div className="lg:col-span-5 sm:col-span-6">
          <Card className="lg:hidden grid  w-full p-2 mb-2 bg-[#fffdf4]">
            <div className="flex justify-between items-center">
              <div>
                <IconButton variant="outlined" className="text-lg" onClick={openDrawer}>
                  <AdjustmentsHorizontalIcon className="h-5 w-5" />
                </IconButton>
              </div>
              <div>
                <Link to="/">
                  <Typography variant="h5" color="blue-gray" className="font-[UTM-Avo] text-orange-600">
                    KEYLAND
                  </Typography>{' '}
                </Link>
              </div>
              <div>
                {' '}
                <Menu>
                  <MenuHandler>
                    <Avatar variant="circular" alt="tania andrew" className="cursor-pointer" src={images.avt} />
                  </MenuHandler>
                  <MenuList>
                    <Link to="/user">
                      <MenuItem className="flex items-center gap-2">
                        <UserCircleIcon className="h-5 w-5" />

                        <Typography variant="small" className="font-medium">
                          Thông tin
                        </Typography>
                      </MenuItem>
                    </Link>
                    <Link to="/changepass">
                      <MenuItem className="flex items-center gap-2">
                        <KeyIcon className="w-5 h-5" />

                        <Typography variant="small" className="font-medium">
                          Đổi mật khẩu
                        </Typography>
                      </MenuItem>
                    </Link>
                    <hr className="my-2 border-blue-gray-50" />
                    <MenuItem className="flex items-center gap-2 ">
                      <ArrowLeftStartOnRectangleIcon className="w-5 h-5" />
                      <Typography
                        variant="small"
                        className="font-medium"
                        onClick={() => {
                          removeCookie('token');
                          removeCookie('token_sv');
                          removeCookie('exp_sv');
                          navigate('/login');
                          window.location.href = '/login';
                        }}
                      >
                        Đăng xuất
                      </Typography>
                    </MenuItem>
                  </MenuList>
                </Menu>
              </div>
            </div>
          </Card>
          <Card className="p-2 h-[calc(100vh-1rem)] overflow-y-scroll shadow-lg">{children}</Card>
        </div>

        <Drawer open={openDrawers} onClose={closeDrawer} className="p-4">
          <div className="mb-6 flex items-center justify-between">
            <Typography variant="h5" color="blue-gray">
              DANH MỤC
            </Typography>
            <IconButton variant="text" color="blue-gray" onClick={closeDrawer}>
              <XMarkIcon className="h-5 w-5" />
            </IconButton>
          </div>
          <hr className="my-2 border-blue-gray-50" />
          <List className="min-w-0">
            {isAdmin(auth) && (
              <Accordion
                open={open === 1}
                icon={
                  <ChevronDownIcon
                    strokeWidth={2.5}
                    className={` mx-auto h-4 w-4 transition-transform ${open === 1 ? 'rotate-180' : ''}`}
                  />
                }
              >
                <ListItem className="p-0" selected={open === 1}>
                  <AccordionHeader onClick={() => handleOpen(1)} className="border-b-0 p-3 min-w-0">
                    <ListItemPrefix>
                      <UserGroupIcon className="h-5 w-5 " />
                    </ListItemPrefix>
                    <Typography color="blue-gray" className="mr-auto font-normal ">
                      Q.L Nhân Viên
                    </Typography>
                  </AccordionHeader>
                </ListItem>
                <Link to="/users" onClick={closeDrawer}>
                  <AccordionBody className="py-1">
                    <List className="p-0 min-w-0">
                      <ListItem>
                        <ListItemPrefix>
                          <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                        </ListItemPrefix>
                        Thêm nhân viên
                      </ListItem>
                    </List>
                  </AccordionBody>
                </Link>
                <Link to="/dsusers" onClick={closeDrawer}>
                  <AccordionBody className="py-1">
                    <List className="p-0 min-w-0">
                      <ListItem>
                        <ListItemPrefix>
                          <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                        </ListItemPrefix>
                        Danh sách nhân viên
                      </ListItem>
                    </List>
                  </AccordionBody>
                </Link>
                {/* <Link to="/team" onClick={closeDrawer}>
                  <AccordionBody className="py-1">
                    <List className="p-0 min-w-0">
                      <ListItem>
                        <ListItemPrefix>
                          <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                        </ListItemPrefix>
                        Thêm NV vào Team
                      </ListItem>
                    </List>
                  </AccordionBody>
                </Link> */}
              </Accordion>
            )}

            <Accordion
              open={open === 2}
              icon={
                <ChevronDownIcon
                  strokeWidth={2.5}
                  className={`mx-auto h-4 w-4 transition-transform ${open === 2 ? 'rotate-180' : ''}`}
                />
              }
            >
              <ListItem className="p-0" selected={open === 2}>
                <AccordionHeader onClick={() => handleOpen(2)} className="border-b-0 p-3">
                  <ListItemPrefix>
                    <NewspaperIcon className="h-5 w-5 " />
                  </ListItemPrefix>
                  <Typography color="blue-gray" className="mr-auto font-normal ">
                    Q.L Bất Động Sản
                  </Typography>
                </AccordionHeader>
              </ListItem>
              <Link to="/addbds" onClick={closeDrawer}>
                <AccordionBody className="py-1">
                  <List className="p-0  min-w-0">
                    <ListItem className="">
                      <ListItemPrefix>
                        <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                      </ListItemPrefix>
                      Thêm tin BĐS
                    </ListItem>
                  </List>
                </AccordionBody>
              </Link>
              <Link to="/dsbds" onClick={closeDrawer}>
                <AccordionBody className="py-1">
                  <List className="p-0  min-w-0">
                    <ListItem className="">
                      <ListItemPrefix>
                        <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                      </ListItemPrefix>
                      Danh sách tin BĐS
                    </ListItem>
                  </List>
                </AccordionBody>
              </Link>
              {/* <Link to="/tkbds">
                  <AccordionBody className="py-1">
                    <List className="p-0  min-w-0">
                      <ListItem className="">
                        <ListItemPrefix>
                          <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                        </ListItemPrefix>
                        Thống Kê BĐS
                      </ListItem>
                    </List>
                  </AccordionBody>
                </Link> */}
            </Accordion>
            <hr className="my-2 border-blue-gray-50" />

            {(isAdmin(auth) || isModerator(auth)) &&
              (auth['wifi'] !== auth['lastiplogin'] && isModerator(auth) ? (
                ''
              ) : (
                <Link to="/dsduyetbds" onClick={closeDrawer}>
                  <ListItem className="">
                    <ListItemPrefix>
                      <InboxIcon className="h-5 w-5" />
                    </ListItemPrefix>
                    Kiểm Duyệt BĐS
                    {countChoDuyet > 0 && (
                      <ListItemSuffix>
                        <Chip
                          value={countChoDuyet}
                          size="sm"
                          variant="ghost"
                          color="blue-gray"
                          className="rounded-full text-deep-orange-600 bg-orange-200"
                        />
                      </ListItemSuffix>
                    )}
                  </ListItem>
                </Link>
              ))}

            {isAdmin(auth) && (
              <Link to="/thongke" onClick={closeDrawer}>
                <ListItem className="">
                  <ListItemPrefix>
                    <ArrowTrendingUpIcon className="h-5 w-5" />
                  </ListItemPrefix>
                  Thống Kê BĐS
                </ListItem>
              </Link>
            )}

            {isAdmin(auth) && (
              <Link to="/wifi" onClick={closeDrawer}>
                <ListItem className="">
                  <ListItemPrefix>
                    <WifiIcon className="h-5 w-5" />
                  </ListItemPrefix>
                  Wifi Nội Bộ
                </ListItem>
              </Link>
            )}

            {isAdmin(auth) && (
              <Link to="/thong-bao" onClick={closeDrawer}>
                <ListItem className="">
                  <ListItemPrefix>
                    <BellAlertIcon className="h-5 w-5" />
                  </ListItemPrefix>
                  Q.L Thông Báo
                </ListItem>
              </Link>
            )}

            {isAdmin(auth) && (
              <div>
                <hr className="my-2 border-blue-gray-50" />
                <Accordion
                  open={open === 3}
                  icon={
                    <ChevronDownIcon
                      strokeWidth={2.5}
                      className={` mx-auto h-4 w-4 transition-transform ${open === 3 ? 'rotate-180' : ''}`}
                    />
                  }
                >
                  <ListItem className="p-0 " selected={open === 3}>
                    <AccordionHeader onClick={() => handleOpen(3)} className="border-b-0 p-3">
                      <ListItemPrefix>
                        <FolderIcon className="h-5 w-5 " />
                      </ListItemPrefix>
                      <Typography color="blue-gray" className="mr-auto font-normal ">
                        Q.L Danh Mục
                      </Typography>
                    </AccordionHeader>
                  </ListItem>
                  <Link to="/diadiem" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Địa Điểm
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/khuquyhoach" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Khu Quy Hoạch
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/quyhoach" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Quy Hoạch
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/phaply" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Pháp Lý
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/huongbds" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Hướng Đất
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/vitri" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Vị Trí
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/loaibds" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Loại BĐS
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/tiennghi" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Tiện Nghi
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                  <Link to="/dactrung" onClick={closeDrawer}>
                    <AccordionBody className="py-1">
                      <List className="p-0  min-w-0">
                        <ListItem className="">
                          <ListItemPrefix>
                            <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                          </ListItemPrefix>
                          Q.L Đặc Trưng
                        </ListItem>
                      </List>
                    </AccordionBody>
                  </Link>
                </Accordion>
              </div>
            )}
          </List>
        </Drawer>
      </div>
    </div>
  );
}

export default DashboardLayout;
